import { hasMobileDeps, hasWebDeps } from '@epihub/web/src/_ctx/deps';
import { createWebProvider } from './web/createWebProvider';
import { createMobileSnackbars } from './mobile/createMobileSnackbarProvider';
import { createWebSnackbars } from './web/createWebSnackbarProvider';
import { createEmotionFunctions } from './emotion';
import { createZustandThemeSlice } from './zustand';
import { type ThemeBuilder } from './builder';
import { createMobileProvider } from './mobile/createMobileProvider';

export function initializeTheme<
  // How to create the theme
  Creator extends object = object,
  // The mutable props of the theme
  State extends object = object,
  // The result, when state changes Creator + State produces theme
  Theme extends object = object,
>(opts: {
  builder: ThemeBuilder<Creator, State, Theme>;
  initialState: State;
}) {
  const zustand = createZustandThemeSlice<Creator, State, Theme>(opts);
  const emotion = createEmotionFunctions<Creator, State, Theme>();

  const snackbars = (() => {
    if (hasWebDeps()) {
      return createWebSnackbars();
    }

    if (hasMobileDeps()) {
      return createMobileSnackbars();
    }

    throw new Error('initialize::either deps.web or deps.mobile dependencies must be injected');
  })();

  const Provider = (() => {
    if (hasWebDeps()) {
      return createWebProvider();
    }

    if (hasMobileDeps()) {
      return createMobileProvider();
    }

    throw new Error('initialize::either deps.web or deps.mobile dependencies must be injected');
  })();

  return {
    snackbars,
    zustand,
    emotion,
    Provider,
  };
}
